import { render, staticRenderFns } from "./receiverDetail.vue?vue&type=template&id=0d10d4cc&scoped=true&"
import script from "./receiverDetail.vue?vue&type=script&lang=js&"
export * from "./receiverDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10d4cc",
  null
  
)

export default component.exports